module.exports = __webpack_public_path__ + "img/014.7965b61e.jpg";